// extracted by mini-css-extract-plugin
export default {"container":"CustomInputMask_container__GRHsY","label":"CustomInputMask_label__0AlyI","input":"CustomInputMask_input__2jwHH"};